import { API } from "aws-amplify";

import { initData, getAutorizationToken } from "utils/utilAmplify";
import { generateErrorResponse } from "utils/helpers";
import { IHouse } from "interfaces/intarfaces";

export const HouseAPI = {
  get: async (path: string = "") => {
    try {
      return await API.get("HostHouse", path, await initData());
    } catch (error) {
      return generateErrorResponse(error);
    }
  },
  create: async (path: string = "", body: Partial<IHouse>) => {
    try {
      return await API.post("HostHouse", path, {
        ...(await initData()),
        body: JSON.parse(JSON.stringify(body)),
      });
    } catch (error) {
      return generateErrorResponse(error);
    }
  },
  update: async (path: string = "", body: Partial<IHouse>) => {
    try {
      return await API.patch("HostHouse", path, {
        ...(await initData()),
        body: JSON.parse(JSON.stringify(body)),
      });
    } catch (error) {
      return generateErrorResponse(error);
    }
  },
  delete: async (path: string = "") => {
    try {
      return await API.del("HostHouse", path, await initData());
    } catch (error) {
      return generateErrorResponse(error);
    }
  },
  deleteImage: async (path: string = "", body: string[]) => {
    try {
      return await API.del("HostHouse", path, {
        ...(await initData()),
        body: {
          file_names: body
        },
      });
    } catch (error) {
      return generateErrorResponse(error);
    }
  },
  upload: async (path: string = "", body: File | string, timestamp: number, order: number) => {
    const formData = new FormData();
    formData.append("image", body);
    const initData: RequestInit = {
      headers: {
        Authorization: `Bearer ${await getAutorizationToken()}`,
        Accept: "image/*",
      },
      body: formData,
    };
    try {
      return await API.post(
        "UsersProfile",
        `${path}?timestamp=${timestamp}&order=${order}`,
        initData
      );
    } catch (error) {
      return generateErrorResponse(error);
    }
  },
  order: async (path: string, order: {file_name: string, order: number}[]) => {
    const initData: RequestInit = {
      headers: {
        Authorization: `Bearer ${await getAutorizationToken()}`,
        Accept: "image/*",
      },
      body: JSON.parse(JSON.stringify({order_data: order})),
    };
    try {
      return await API.post(
          "UsersProfile",
          path,
          initData
      );
    } catch (error) {
      return generateErrorResponse(error);
    }
  }
};
